export default {
  List: {
    Title: "Mẫu văn bản",
    UploadButton: "Tải lên mẫu văn bản",
    Search: "Tìm kiếm mẫu văn bản theo tên, loại tệp,...",
    TemplateName: "Tên mẫu văn bản",
    Attachment: "Tên tệp",
    FileSize: "Dung lượng (KB)",
    Note: "Ghi chú",
  },
  Detail: {
    Upload: "Tải lên mẫu văn bản",
    Edit: "Sửa mẫu văn bản",
    Status: "Tình trạng",
    TemplateName: "Tên mẫu",
    Note: "Ghi chú",
    Type: "Loại mẫu",
  },
  Popup: {
    Title: "Tải mẫu văn bản",
    Next: "Tiếp theo",
  },
};
